<template>
  <div class="users-list" v-loading="loading">
    <div class="filter">
      <date-picker
        :editable="false"
        ref="datePicker"
        placeholder="Фильтр по дате"
        v-model="datetimeRange"
        @change="changeDateTime"
        range
      ></date-picker>

    </div>
    <el-table
      :data="projects_users"
      style="width: 100%"
    >
      <el-table-column
        width="200"
        prop="id"
        label="id"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
      >
      </el-table-column>
      <el-table-column
        width="200"
        prop="user"
        label="Активных клиентов"
      >
      </el-table-column>
    </el-table>

    <h2>Приглашенный</h2>
    <el-table
      :data="projects"
      style="width: 100%"
    >
      <el-table-column
        width="200"
        prop="id"
        label="id"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
      >
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'ClientInfo',
  components: {DatePicker},
  data() {
    return {
      loading: false,
      projects: [],
      projects_users: [],

      datetimeRange: [
        new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
    };
  },

  methods: {
    getClients() {
      // filterArray.push(
      //   ['dateunix', '<', dayjs(this.datetimeRange[1]).add(1, 'day').unix()],
      // );
      // filterArray.push(
      //   ['dateunix', '>', dayjs(this.datetimeRange[0]).subtract(1, 'minutes').unix()],
      // );

      this.projects_users.forEach((project, index) => {
        myFirestore
          .collection('history')
          .where('project', '==', project.id)
          .where('date', '>', dayjs(this.datetimeRange[0]).subtract(1, 'minutes').unix())
          .where('date', '<', dayjs(this.datetimeRange[1]).add(1, 'day').unix())
          .get()
          .then((data) => {
            const users = [];
            data.forEach((subDoc) => {
              users.push({
                ...subDoc.data()
              })
            });

            var tempResult = {}

            for(let user of users)
              tempResult[user.uid] = {
                ...user,
                count: tempResult[user.uid] ? tempResult[user.uid].count + 1 : 1
              }

            let result = Object.values(tempResult)

            this.projects_users[index].user = result.length
          })
      })
    },
    changeDateTime() {
      this.getClients();
    },
  },

  mounted() {
    myFirestore
      .collection('projects')
      .where('owner', '==', this.$route.params.id)
      .get()
      .then((data) => {
        data.forEach((subDoc) => {
          this.projects_users.push({
            id: subDoc.id,
            ...subDoc.data(),
            user: 0
          })
          this.getClients();
        });
      })


    myFirestore
      .collection('projects')
      .where(`rules.${this.$route.params.id}`, '>', '')
      .get()
      .then((data) => {
        data.forEach((subDoc) => {
          const project = subDoc.data();
          if(project.owner !== this.$route.params.id) {
            this.projects.push({
              id: subDoc.id,
              ...project,
              user: 0
            })
          }
        });
      })
  }
};
</script>

<style scoped lang="scss">
.users-list {
  max-width: 1024px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.input-search {
  margin-top: 12px;
}

.name {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  small {
    font-size: 12px;
    font-weight: bold;
  }
}

.users-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .users-li, > > > .users-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 64px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;


    &.active {
      background: rgba(54, 118, 203, 0.26) !important;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.add-user {
  margin-top: 22px;
  text-decoration: none;
  color: #3676CB;

  &:hover {
    color: #222;
  }
}

.controls {
  margin-top: 30px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
}

.users-invites {
  margin-top: 20px;

  .name, .email {
    opacity: 0.5;
  }
}

.users-controls {
  display: flex;
  justify-content: flex-end;

  i {
    margin-left: 16px;
  }
}

.is-invited {
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/Clients/ClientInfo.vue